import { Component } from "react";
import React from "react";

import { Button } from '@material-ui/core'

import PaperBlock from "../../../ui/PaperBlock.js"

/**
 * Панель выбора пользователя.
 * 
 * @param props.selected - выбранный ранее пользователь.
 * @param props.onSelectButtonClick - нажатие на кнопку выбрать пользователя (Ведущего).
 */

class SelectUserPanel extends Component {

    render() {
        return <PaperBlock style = {{width: "100%", padding: "0px"}}>
            <div style={{margin: "10px", display: "flex"}}>

                <div style={{flex: "1 1 auto", display: "flex", alignItems: "center"}}>
                    {this.props.selected ? this.props.selected.name : ""}
                </div>
                
                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSelectButtonClick === "function") {
							this.props.onSelectButtonClick()
						}
					}}
				>
					Выбрать ведущего
				</Button>                

            </div>
        </PaperBlock>
    }

}

export default SelectUserPanel